<app-widget-base
  #container
  [title]="''"
  (onCollapse)="emitCollapse($event)"
  [headerOverlay]="selectorOpened"
>
  <div *ngIf="loading" class="linear-progress">
    <div class="linear-progress-bar"></div>
  </div>
  <div class="widget-header">
    <h4>{{ title }}</h4>
    <app-selector
      *ngIf="!collapsed && !loading"
      [autoClose]="true"
      [options]="options"
      [selected]="current"
      (onOpen)="selectorOpened = $event"
      (onSelectOption)="onSelectTarget($event)"
    ></app-selector>
  </div>
  <div class="content" [ngStyle]="{ zIndex: selectorOpened ? 0 : 1 }">
    <div #tooltip class="tooltip hidden">
      <div class="tooltip-content">
        <p>
          <span class="name"></span>
          <span class="category"></span>
        </p>
        <p>
          <span class="value"></span>
          <small class="unit"></small>
        </p>
      </div>
    </div>
    <div *ngIf="config.colorScale">
      <div *ngFor="let serie of legends; let serieIndex = index" class="legend">
        <div class="serie-name" *ngIf="legends.length === 2">
          {{ (serieIndex === 0 ? 'Current' : 'Compared') | translate }}
        </div>
        <div
          class="legend-item"
          [attr.data-tooltip]="cat.category_name | translate"
          [class.selected]="selectedCategory === cat.category"
          *ngFor="let cat of serie; let index = index"
        >
          <div
            class="color"
            [style.background-color]="getColor(cat, index, serieIndex)"
          ></div>
          <p class="name">
            {{ cat.category_name | translate }}
          </p>
        </div>
      </div>
    </div>
    <svg #svg></svg>
  </div>
</app-widget-base>
